export default [
	{
		id: '01',
		name_es: 'Transferencias y Traspasos',
		name_en: 'Transfers',
	},
	{
		id: '02',
		name_es: 'Órdenes permanentes',
		name_en: 'Standing orders',
	},
	{
		id: '03',
		name_es: 'Cambio de datos personales',
		name_en: 'Personal data change',
	},
	{
		id: '04',
		name_es: 'Compra / venta de valores',
		name_en: 'Shares purchases',
	},
	{
		id: '05',
		name_es: 'Préstamos y financiación',
		name_en: 'Loans',
	},
	{
		id: '06',
		name_es: 'Devolución de adeudos',
		name_en: 'Direct debit return',
	},
	{
		id: '07',
		name_es: 'Compra / venta de divisas',
		name_en: 'Currency purchases',
	},
	{
		id: '08',
		name_es: 'Reembolso premium',
		name_en: 'Premium reimbursement',
	},
	{
		id: '09',
		name_es: 'Suscripción premium',
		name_en: 'Premium subscription',
	},
	{
		id: '10',
		name_es: 'Transferencias internacionales',
		name_en: 'International transfers',
	},
	{
		id: '11',
		name_es: 'Solicitud de talonario',
		name_en: 'Checkbook request',
	},
	{
		id: '12',
		name_es: 'Órdenes Renta fija',
		name_en: 'Fixed-income orders',
	},
	{
		id: '13',
		name_es: 'Tarjetas',
		name_en: 'Cards',
	},
	{
		id: '14',
		name_es: 'Banca electrónica',
		name_en: 'Online banking',
	},
	{
		id: '99',
		name_es: 'Otras órdenes',
		name_en: 'Others',
	},
];
